import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  return (
    <EducationModuleLayout
      progressStage={8}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-green no-bold no-margin">Let’s review ASSIST</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <img
                className="img-block img-responsive"
                src={AssistGraphic}
                alt="Help is available"
              />
              <p>We just learned the six components in assisting someone:</p>
              <ol className="list">
                <li className="list-item">
                  Choose a place and time
                </li>
                <li className="list-item">
                  Validate their feelings
                </li>
                <li className="list-item">
                  Listen actively
                </li>
                <li className="list-item">
                  Don’t promise to keep secrets
                </li>
                <li className="list-item">
                  Avoid giving advice
                </li>
                <li className="list-item">
                  Instill a sense of hope
                </li>
              </ol>
              <p>
                You can reinforce your comfort level by spending time practicing these components.
              </p>
              <p>
                It’s important to recognize the boundaries or limitations of the assisting
                role. When interacting with someone experiencing a mental health challenge,
                our natural tendency is to try to “fix the problem”. Most of the time you
                won’t be able to solve someone’s problem, but you can help the person feel
                supported. Working with them to navigate the options of resources and
                services is a necessary aspect of Refer. In the Refer section, we will
                learn how to facilitate referrals and become more familiar with
                campus and community resources and services.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-green previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.REFER} className="btn btn-green next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistI = connect.role(AssistPage);

export default AssistI;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistI/index.jsx